import { useState, useRef } from "react";
import { toast } from "react-toastify";
import { dictionaryCRUD } from "../../../actions/dictionary";
import { selector } from "../../../api";

export const UploadDictionary = ({ setIndex, index }) => {
  const user = selector.User();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const closeRef = useRef();
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (!selectedFile.name.endsWith('.csv')) {
        toast.error("Please select a CSV file", { autoClose: 5000 });
        return;
      }
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleUpload = () => {
    if (!file) {
      toast.error("Please select a file to upload", { autoClose: 5000 });
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", user.id);

    dictionaryCRUD.uploadDictionary(formData)
      .then(() => {
        toast.success("Dictionary data uploaded successfully!", { autoClose: 5000 });
        setIndex(index + 1);
        handleReset();
        closeRef.current.click();
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.error || "Failed to upload dictionary data";
        toast.error(errorMessage, { autoClose: 5000 });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleReset = () => {
    setFile(null);
    setFileName("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className="modal fade uploadDictionaryModal" tabIndex="-1" aria-labelledby="uploadDictionaryModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="uploadDictionaryModalLabel">
              <i className="bi bi-upload me-2"></i>
              Upload Dictionary
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeRef}></button>
          </div>
          <div className="modal-body">
            <div className="alert alert-info">
              <h6 className="alert-heading"><i className="bi bi-info-circle me-2"></i>CSV File Format</h6>
              <p className="mb-2">Your CSV file should have the following columns:</p>
              <ul className="mb-0">
                <li><strong>dictionary_code</strong> - Dictionary code (max 5 characters)</li>
                <li><strong>dictionary_name_en</strong> - English name</li>
                <li><strong>dictionary_name_sw</strong> - Swahili name</li>
              </ul>
              <hr />
              <p className="mb-0 small">
                <strong>Example:</strong><br />
                dictionary_code,dictionary_name_en,dictionary_name_sw<br />
                GEN,Gender,Jinsia
              </p>
            </div>

            <div className="mb-3">
              <label htmlFor="csvFile" className="form-label">Select CSV File <span className="text-danger">*</span></label>
              <input
                type="file"
                className="form-control"
                id="csvFile"
                accept=".csv"
                onChange={handleFileChange}
                ref={fileInputRef}
              />
              {fileName && (
                <div className="mt-2 text-success">
                  <i className="bi bi-file-earmark-check me-1"></i>
                  Selected: {fileName}
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleReset}>
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleUpload} disabled={loading || !file}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Uploading...
                </>
              ) : (
                <>
                  <i className="bi bi-upload me-2"></i>
                  Upload
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
